import Enchantehome1 from '../../Media/homeimages/Enchante 15.webp'
import Enchantehome2 from '../../Media/homeimages/Enchante 15.webp'





const Enchantehomeimages =[
Enchantehome1,Enchantehome2
]

export default Enchantehomeimages;